// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bcms-modal-wrapper {
  position: fixed;
  top:0px;
  left:0px;
  height:100vh;
  width:100%;
  display:none;
  transition: all 0.3s ease-in-out;
}

.bcms-modal-wrapper.open {
  display: block;
  z-index: 10;
}

.bcms-modal-overlay {
  position:absolute;
  top:0px;
  left:0px;
  height:100vh;
  width:100%;
  background:#000;
  opacity: 0;
  transition: all 0.3s ease-in-out;
}

.bcms-modal-wrapper.open .bcms-modal-overlay {
  opacity:.5;
}

.bcms-modal {
  position: absolute;
  border:1px solid #000;
  width:400px;
  height:400px;
  background:#FFF;
  top:40px;
  margin:auto;
  margin-left: 50%;
  transform: translateX(-50%);
  display:none;
}

.bcms-modal-wrapper.open .bcms-modal {
  display:block;
}

.bcms-modal-header {
  border-bottom:1px solid #000;
  padding:5px;
}

.bcms-modal-content {
  padding:5px;
}

.bcms-modal-footer {
  border-top:1px solid #000;
  padding:5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/BCMSModal/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":[".bcms-modal-wrapper {\n  position: fixed;\n  top:0px;\n  left:0px;\n  height:100vh;\n  width:100%;\n  display:none;\n  transition: all 0.3s ease-in-out;\n}\n\n.bcms-modal-wrapper.open {\n  display: block;\n  z-index: 10;\n}\n\n.bcms-modal-overlay {\n  position:absolute;\n  top:0px;\n  left:0px;\n  height:100vh;\n  width:100%;\n  background:#000;\n  opacity: 0;\n  transition: all 0.3s ease-in-out;\n}\n\n.bcms-modal-wrapper.open .bcms-modal-overlay {\n  opacity:.5;\n}\n\n.bcms-modal {\n  position: absolute;\n  border:1px solid #000;\n  width:400px;\n  height:400px;\n  background:#FFF;\n  top:40px;\n  margin:auto;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  display:none;\n}\n\n.bcms-modal-wrapper.open .bcms-modal {\n  display:block;\n}\n\n.bcms-modal-header {\n  border-bottom:1px solid #000;\n  padding:5px;\n}\n\n.bcms-modal-content {\n  padding:5px;\n}\n\n.bcms-modal-footer {\n  border-top:1px solid #000;\n  padding:5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
